<template>
    <w-btn
        color="blue darken-2"
        :loading="loading"
        :text="$t('common.reload')"
        icon="mdi-reload"
        @press="press"
    />
</template>

<script>
export default {
    name: 'WBtnReload',
    props: {
        loading: Boolean,
    },
    emits: ['press'],
    setup(props, {emit}) {
        function press() {
            emit('press');
        }

        return {
            press,
        }
    }
}
</script>

<style scoped>

</style>